import React from "react";
import ResetPasswordForm from "../components/resetPasswordForm";
import Navbar from "../components/navbar";
import Footer from "../components/footer";

function ResetPasswordPage() {
  return (
    <>
      <Navbar />
      <ResetPasswordForm />
      <Footer />
    </>
  );
}

export default ResetPasswordPage;
